<script>
    import { t } from "$lib/i18n/translations";
    import ClipboardCopy from "$components/icons/ClipboardCopy.svelte";

    export let click;
</script>

<div
    class="cursor-pointer inline-block"
    on:click={click}
    aria-hidden="true"
    aria-label={$t("save.clear_input")}
>
    <ClipboardCopy />
</div>

<style>
</style>
